<template>
    <div class="account-list">
        <vue-loading v-show="loading"></vue-loading>
        <table cellspacing="0">
            <thead>
                <tr>
                    <th width="10%">模拟资金账号</th>
                    <th width="10%">初始资金量</th>
                    <th width="10%">初始密码</th>
                    <th width="20%">备注</th>
                    <th width="15%">生成时间</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="account in accountList" :key="account._id">
                    <td align="center">
                        <span class="operation" @click="copy(account.account_id)">{{account.account_id}}</span>
                    </td>
                    <td align="center">{{account.asset | unitConversion}}</td>
                    <td align="center">
                        <span class="operation" @click="copy(account.pwd)">{{account.pwd}}</span>
                    </td>
                    <td align="center">{{account.remark}}</td>
                    <td align="center">{{account.created_at}}</td>
                </tr>
                <!-- <tr v-if="accountList.length == 0" >
                    <td colspan="6">点击添加账户按钮添加账户</td>
                </tr> -->
            </tbody>
        </table>
    </div>
</template>
<script>
// import axios from 'axios'
export default {
    props: {
        accountList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
            loading: false,
            openIndex: -1
        }
    },
    methods: {
        copy (value) {
            let input = document.createElement('input')
            document.body.appendChild(input)
            input.style.position = 'fixed'
            input.style.top = '-50px'
            input.style.left = '-50px'
            input.style.opacity = 0
            input.value = value
            input.focus()
            input.setSelectionRange(0, input.value.length)
            document.execCommand('copy', true)
            document.body.removeChild(input)
            // this.$tip({
            //     message: '复制成功',
            //     duration: 2000,
            //     type: 'success'
            // })
            this.$message({
                message: '复制成功',
                duration: 2000,
                type: 'success'
            })
        }
    },
    filters: {
        unitConversion: (num) => {
            num = Number(num)
            if (isNaN(num)) return ''
            num = (num / 10000).toFixed(2)
            return num + '万'
        }
    }
}
</script>

<style lang="scss" scoped>
.account-list {
    padding-top: 30px;
    table {
        table-layout: fixed;
        // min-height: 460px;
        width: 100%;
        border-collapse: collapse;
        word-wrap: break-word;
        thead {
            width: 100%;
            height: 36px;
            background: #fafafa;
            th{
                height: 36px;
                color: #4a4a4a;
                font-size: 12px;
                font-weight: 100;
            }
        }
        tbody{
            background: white;
            width: 100%;
            tr {
                border: 1px solid #e4e4e4;
                td {
                    height: 30px;
                    font-size: 14px;
                    .operation {
                        font-size: 14px;
                        color: #108ee9;
                        cursor: pointer;
                        user-select: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/simuAccountApplication/list.vue